define('area_init/error_pages',['modules/error_pages'], function (ErrorPages) {
  ErrorPages.sendRecommendationData();
});

